// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"cbefcba5","513":"68e9e0ca","703":"c9716eff"}[chunkId] + ".chunk.js";
};